import Vue from 'vue';

Vue.component('Confirm', require('@c/Confirm').default);
Vue.component('Control', require('@c/Control').default);
Vue.component('FileUpload', require('@c/FileUpload').default);
Vue.component('Header', require('@c/Header').default);
Vue.component('PageTab', require('@c/PageTab/PageTab').default);
Vue.component('Otp', require('@c/Otp').default);
Vue.component("Watch", require("@c/Watch").default);
//ui
Vue.component('FullPage', require('@c/ui/FullPage').default);
Vue.component('OtpInput', require('@c/ui/OtpInput').default);
Vue.component('ResultPage', require('@c/ui/ResultPage').default);
Vue.component('Version', require('@c/ui/Version').default);
Vue.component('Webview', require('@c/ui/Webview').default);